import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import LogoText from "../../assets/img/salad_exchange.png";
import BigData from "../../assets/img/bigdata.png";
import Benefit from "../../assets/img/benefit.png";
import WHY from "../../assets/img/why.png";
import Phone from "../../assets/img/phone.png";
import Wallet from "../../assets/img/ico_wallet.png";
import Lock from "../../assets/img/ico_lock.png";
import Chart from "../../assets/img/ico_chart.png";
import IconApproval from "../../assets/img/quality.png";
import IconRecording from "../../assets/img/edit.png";
import IconRealTime from "../../assets/img/clock.png";
import IconPayroll from "../../assets/img/wages.png";
import StepOne from "../../assets/img/step_one.png";
import StepTwo from "../../assets/img/step_two.png";
import StepThree from "../../assets/img/step_three.png";
import GoogleEn from "../../assets/img/badge-ps.png";
import GoogleJp from "../../assets/img/badge-ps-jp.png";
import GoogleId from "../../assets/img/badge-ps-id.png";
import {
    FormControl,
    IconButton,
    InputAdornment,
    OutlinedInput,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SendIcon from "@mui/icons-material/Send";
import FB from "../../assets/img/Facebook.png";
import IG from "../../assets/img/Instagram.png";
import TW from "../../assets/img/Twitter.png";
import YT from "../../assets/img/Youtube.png";
import MenuIcon from "@mui/icons-material/Menu";
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import LanguageSelector from "../layouts/language";
import { CheckCircle, CorporateFareRounded, EmailRounded, Person, PhoneOutlined, PhoneRounded, Refresh, VerifiedUserRounded } from "@mui/icons-material";
import emailjs from 'emailjs-com';
import { useTranslation } from "../../store/languageSlice/languageHook";

const badgeMap = {
  "en-US": GoogleEn,
  "jp-JP": GoogleJp,
  "id-ID": GoogleId,
};

function HomePage() {
    const [sideBar, setSideBar] = React.useState(0);
    const [show, setShow] = useState(false);
    const [values, setValues] = React.useState({
        fullName: "",
        company: "",
        email: "",
        phone: "",
        description: "",
    });

    const [captchaQuestion, setCaptchaQuestion] = useState("");
    const [captchaAnswer, setCaptchaAnswer] = useState("");
    const [userAnswer, setUserAnswer] = useState("");

    const { active: activeLang } = useTranslation();
    const lang = activeLang; 
    

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const scrollMenu = (e, hash) => {
        let menu = document.getElementById(hash);
        e.preventDefault();
        menu && menu.scrollIntoView({ behavior: "smooth", block: "start" });
        window.history.pushState(hash, hash, "/");
    };

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    function MenuBar() {
        return (
            <>
                <Link to={"/"} onClick={() => scrollToTop()}>
                    {"HOME_NB_1".tr()}
                </Link>
                <Link to={"/"} onClick={(e) => scrollMenu(e, "feature")}>
                    {"HOME_NB_2".tr()}
                </Link>
                <Link to={"/"} onClick={(e) => scrollMenu(e, "tutorials")}>
                    {"HOME_NB_3".tr()}
                </Link>
                <Link to={"/"} onClick={(e) => scrollMenu(e, "contact")}>
                    {"HOME_NB_4".tr()}
                </Link>
            </>
        );
    }

    const openSideBarMenu = () => {
        setSideBar(50);
    };

    const closeSideBarMenu = () => {
        setSideBar(0);
    };

    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value,
        });
    };

    const generateCaptcha = () => {
        const a = Math.floor(Math.random() * 10);
        const b = Math.floor(Math.random() * 10);
        setCaptchaQuestion(`${a} + ${b}`);
        setCaptchaAnswer((a + b).toString());
        setUserAnswer("");
    };

    const submitForm = async (e) => {
        e.preventDefault();

        if (userAnswer !== captchaAnswer) {
            alert("Jawaban captcha salah! Silakan coba lagi.");
            generateCaptcha();
            return;
        }

        console.log(`Full Name: ${values.fullName}`);
        console.log(`Company: ${values.company}`);
        console.log(`Email: ${values.email}`);
        console.log(`Phone: ${values.phone}`);
        console.log(`Description: ${values.description}`);

        const templateParams = {
            name: values.fullName,
            company: values.company,
            email: values.email,
            phone: values.phone,
            message: values.description,
        };

        emailjs.send(
            'service_n794446',      // Service ID dari EmailJS
            'template_8nfmb89',     // Template ID dari EmailJS
            templateParams,
            '2DQJTvc08YoqnA4bm'       // Public Key dari EmailJS
        ).then(
            (result) => {
                console.log("Email terkirim!", result.text);
                alert("Pesan berhasil dikirim!");
            },
            (error) => {
                console.error("Gagal mengirim email:", error.text);
                alert("Gagal mengirim pesan.");
            }
        );

        generateCaptcha(); // Reset captcha setelah submit
    }

    useEffect(() => {
        generateCaptcha();
    }, []);

    // const settings = {
    //     dots: false,
    //     infinite: true,
    //     autoplay: true,
    //     autoplaySpeed: 2000,
    //     pauseOnHover: true,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    // };

    return (
        <div className="sal-homepage">
            <div className="sal-homepage-header">
                <div className="container">
                    <div className="sal-homepage-header-container d-none d-md-flex">
                        <div className="sal-homepage-header-nav">
                            <img src={LogoText} alt={"Sal Ad"} width={160} />
                            <MenuBar />
                        </div>
                        <div className="sal-homepage-header-btn d-flex align-items-center">
                            <LanguageSelector />
                            {/* <Link
                                to={"/signin"}
                                className="btn btn-info sal-btn-account-custom ms-2"
                            >
                                Sign In
                            </Link> */}
                        </div>
                    </div>

                    <div className="sal-homepage-header-containermob d-block d-md-none">
                        <div className="sal-homepage-header-navmob d-block d-md-none">
                            <div className="sal-sidenav" style={{ width: `${sideBar}%` }}>
                                <IconButton
                                    className="sal-close-button"
                                    onClick={() => closeSideBarMenu()}
                                >
                                    <HighlightOffIcon />
                                </IconButton>
                                <MenuBar />
                            </div>
                            <div className="w-100 d-flex align-items-center justify-content-between">
                                <img src={LogoText} alt={"Sal Ad"} width={130} />
                                <span onClick={() => openSideBarMenu()}>
                                    <MenuIcon className="fill-primary" />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="row sal-homepage-header-content">
                        <div
                            className="col-12 sal-homepage-header-content-right d-block d-md-none"
                            align="center"
                        >
                            <img src={Phone} alt="Phone" width={"100%"} />
                        </div>
                        <div className="col-12 col-md-5 sal-homepage-header-content-left">
                            <div className="sal-main-text">
                                {/* Desktop View */}
                                <h1 className="d-none d-md-block">{"HOME_MT_1".tr()}</h1>
                                <h2 className="d-none d-md-block">{"HOME_MT_1_5".tr()}</h2>
                                <p className="d-none d-md-block">{"HOME_MT_2".tr()}</p>
                                {/* Mobile View */}
                                <h3 className="d-block d-md-none text-center">
                                    {"HOME_MT_1".tr()}
                                </h3>
                                <p className="d-block d-md-none text-center">
                                    {"HOME_MT_2".tr()}
                                </p>
                                {/* Desktop View */}
                                <div className="d-none d-md-block">
                                    <Button
                                        variant="primary"
                                        className="me-3 sal-btn-get-started-badge"
                                    >
                                           <a
                                                href={
                                                "https://play.google.com/store/apps/details?id=com.saladnet.app"
                                                }
                                                target="_blank"
                                            >
                                            <img
                                                src={badgeMap[lang] || GoogleEn} // fallback to EN
                                                alt={"salad-ps"} // alt text from translations
                                            />
                                        </a>
                                        {/* {"HOME_GET_STARTED".tr()} */}
                                    </Button>
                                    <Button variant="primary" className="sal-btn-learn-more">
                                        {"HOME_LEARN_MORE".tr()}
                                    </Button>
                                </div>
                                {/* Mobile View */}
                                <div className="d-block align-items-center d-md-none">
                                    <div className="row align-items-center pb-4">
                                        <div className="col-6">
                                            <Button
                                                variant="primary"
                                                className="me-3 font-12 sal-btn-get-started-badge w-100"
                                            >
                                                  <a
                                                        href={
                                                        "https://play.google.com/store/apps/details?id=com.saladnet.app"
                                                        }
                                                        target="_blank"
                                                    >
                                                 <img
                                                    src={badgeMap[lang] || GoogleEn} // fallback to EN
                                                    alt={"salad-ps"} // alt text from translations
                                                />
                                                </a>
                                                {/* {"HOME_GET_STARTED".tr()} */}
                                            </Button>
                                        </div>
                                        <div className="col-6">
                                            <Button
                                                variant="primary"
                                                className="font-12 sal-btn-learn-more w-100"
                                            >
                                                {"HOME_LEARN_MORE".tr()}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="col-12 col-md-7 sal-homepage-header-content-right d-none d-md-block"
                            align="center"
                        >
                            <img src={Phone} alt="Phone" width={"100%"} />
                        </div>
                    </div>
                    {/* Desktop View */}
                    {/* <div className="sal-homepage-header-extra d-none d-md-flex">
                        <div>
                            <h3>90K+</h3>
                            <p className="mb-0">{"HOME_REGISTERED_USERS".tr()}</p>
                        </div>
                        <div>
                            <h3>40K+</h3>
                            <p className="mb-0">{"HOME_ACTIVE_USERS".tr()}</p>
                        </div>
                        <div>
                            <h3>150K+</h3>
                            <p className="mb-0">
                                {"HOME_NUMBER_OF".tr()}
                            </p>
                        </div>
                        <div>
                            <h3>{"HOME_US4MN".tr()}</h3>
                            <p className="mb-0">{"HOME_VALUE_OF".tr()}</p>
                        </div>
                        <div>
                            <h3>{"HOME_15_DAYS".tr()}</h3>
                            <p className="mb-0">{"HOME_AVERAGE_LOAN".tr()}</p>
                        </div>
                    </div> */}
                    {/* Mobile View */}
                    {/* <div className="sal-homepage-header-extramob d-block d-md-none">
                        <Slider {...settings}>
                            <div className="sal-extramob-box">
                                <h6>90K+</h6>
                                <p className="mb-0">{"HOME_REGISTERED_USERS".tr()}</p>
                            </div>
                            <div className="sal-extramob-box">
                                <h6>40K+</h6>
                                <p className="mb-0">{"HOME_ACTIVE_USERS".tr()}</p>
                            </div>
                            <div className="sal-extramob-box">
                                <h6>150K+</h6>
                                <p className="mb-0">
                                    {"HOME_NUMBER_OF".tr()}
                                </p>
                            </div>
                            <div className="sal-extramob-box">
                                <h6>{"HOME_US4MN".tr()}</h6>
                                <p className="mb-0">{"HOME_VALUE_OF".tr()}</p>
                            </div>
                            <div className="sal-extramob-box">
                                <h6>{"HOME_15_DAYS".tr()}</h6>
                                <p className="mb-0">{"HOME_AVERAGE_LOAN".tr()}</p>
                            </div>
                        </Slider>
                    </div> */}
                </div>
            </div>
            <div id="feature" className="sal-homepage-content pt-4">
                <div className="sal-homepage-content-one">
                    {/* Desktop View */}
                    <div className="container d-none d-md-block">
                        <h1>
                            {"HOME_WHY_COMPANIES".tr()}
                        </h1>
                        <h2>
                            {"HOME_MANUAL_CASH".tr()}
                        </h2>
                        <h3>
                            {"HOME_WITH_CLOUDE".tr()}
                        </h3>
                        <div className="sal-homepage-content-one-extra">
                            <div>
                                <p>
                                    {"HOME_ACCELERATE_THE_SUBMISSION".tr()}
                                </p>
                            </div>
                            <div>
                                <p>
                                    {"HOME_MONITOR_THE_USE".tr()}
                                </p>
                            </div>
                            <div>
                                <p>
                                    {"HOME_OPTIMIZE_CASH_FLOW".tr()}
                                </p>
                            </div>
                            <div>
                                <p>
                                    {"HOME_INCREASE_TRANSPARENCY_BETWEEN".tr()}
                                </p>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div
                                className="col-12 col-md-6 d-flex align-items-center justify-content-center"
                                align="center"
                            >
                                <img src={BigData} alt="Technology" width={"90%"} />
                            </div>
                            <div className="sal-features col-12 col-md-6">
                                <h4 className="sal-features-title">
                                    {"HOME_KEY_FEATURES_OF_SALAD".tr()}
                                </h4>
                                <p className="sal-features-desc">
                                    {"HOME_EMPLOYEES_CAN_REQUEST".tr()}
                                </p>
                                <div className="row mb-4 align-items-center">
                                    <div className="col-12 col-md-2">
                                        <div className="sal-badge-icon">
                                            <img src={IconApproval} alt="Approval" width={40} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-10">
                                        <p className="sal-bigdata-text-one">
                                            {"HOME_FAST_APPROVAL".tr()}
                                        </p>
                                        <p className="sal-bigdata-text-two mb-0">
                                            {"HOME_SETUP_APPROVAL".tr()}
                                        </p>
                                    </div>
                                </div>
                                <div className="row mb-4 align-items-center">
                                    <div className="col-12 col-md-2">
                                        <div className="sal-badge-icon">
                                            <img src={IconRecording} alt="Recording" width={40} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-10">
                                        <p className="sal-bigdata-text-one">
                                            {"HOME_AUTOMATIC_RECORDING".tr()}
                                        </p>
                                        <p className="sal-bigdata-text-two mb-0">
                                            {"HOME_ALL_CASH_ADVANCE".tr()}
                                        </p>
                                    </div>
                                </div>
                                <div className="row mb-4 align-items-center">
                                    <div className="col-12 col-md-2">
                                        <div className="sal-badge-icon">
                                            <img src={IconRealTime} alt="Real Time" width={40} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-10">
                                        <p className="sal-bigdata-text-one">
                                            {"HOME_REAL_TIME_MONITORING".tr()}
                                        </p>
                                        <p className="sal-bigdata-text-two mb-0">
                                            {"HOME_VIEW_SUBMISSION".tr()}
                                        </p>
                                    </div>
                                </div>
                                <div className="row align-items-center">
                                    <div className="col-12 col-md-2">
                                        <div className="sal-badge-icon">
                                            <img src={IconPayroll} alt="Payroll" width={40} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-10">
                                        <p className="sal-bigdata-text-one">
                                            {"HOME_PAYROLL_INTEGRATION".tr()}
                                        </p>
                                        <p className="sal-bigdata-text-two mb-0">
                                            {"HOME_CASH_ADVANCE_DEDUCTIONS".tr()}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="sal-features col-12 col-md-6">
                                <h4 className="sal-features-title mb-5 mt-5">
                                    {"HOME_BENEFITS_FOR_COMPANY".tr()}
                                </h4>
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <CheckCircle className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_ADMINISTRATIVE_EFFICIENCY".tr()}
                                                </p>
                                                <p className="sal-bigdata-text-two-extra mb-0">
                                                    {"HOME_REDUCE_MANUAL_WORK".tr()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <CheckCircle className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_FINANCIAL_TRANSPARENCY".tr()}
                                                </p>
                                                <p className="sal-bigdata-text-two-extra mb-0">
                                                    {"HOME_ALL_PARTIES_CAN".tr()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <CheckCircle className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_EMPLOYEE_SATISFACTION".tr()}
                                                </p>
                                                <p className="sal-bigdata-text-two-extra mb-0">
                                                    {"HOME_FAST_AND_CLEAR".tr()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <CheckCircle className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_BETTER_BUDGET_CONTROL".tr()}
                                                </p>
                                                <p className="sal-bigdata-text-two-extra mb-0">
                                                    {"HOME_ENSURE_FUNDS_ARE_USED".tr()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <CheckCircle className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_SALAD_DIGITAL_CASH".tr()}
                                                </p>
                                                <p className="sal-bigdata-text-two-extra mb-0">
                                                    {"HOME_EMPLOYEE_FILL_OUT_CASH".tr()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <CheckCircle className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_APPROVAL".tr()}
                                                </p>
                                                <p className="sal-bigdata-text-two-extra mb-0">
                                                    {"HOME_SUPERVISORS_RECEIVE".tr()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <CheckCircle className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_DISBURSEMENT".tr()}
                                                </p>
                                                <p className="sal-bigdata-text-two-extra mb-0">
                                                    {"HOME_CASH_ADVANCE_FUNDS_ARE".tr()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <CheckCircle className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_RECORDING_AND_DEDUCATION".tr()}
                                                </p>
                                                <p className="sal-bigdata-text-two-extra mb-0">
                                                    {"HOME_TRANSACTIONS_ARE_AUTO".tr()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-12 col-md-6 d-flex align-items-center justify-content-center"
                                align="center"
                            >
                                <img src={Benefit} alt="Benefit" width={"90%"} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div
                                className="col-12 col-md-6 d-flex align-items-center justify-content-center"
                                align="center"
                            >
                                <img src={WHY} alt="Benefit" width={"90%"} />
                            </div>
                            <div className="sal-features col-12 col-md-6">
                                <h4 className="sal-features-title mb-5 mt-5">
                                    {"HOME_WHY_CHOOSE_SALAD".tr()}
                                </h4>
                                <div className="row mb-2">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <CheckCircle className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_EXPERIENCED_IN_HRIS".tr()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <CheckCircle className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_DATA_SECURITY_GUARANTEED".tr()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <CheckCircle className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_FULL_SUPPORT_FROM".tr()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <CheckCircle className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_INTEGRATED_WITH_HR".tr()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Button
                                    variant="primary"
                                    className="mt-5 mb-5 sal-btn-get-started"
                                    onClick={handleShow}
                                >
                                    {"HOME_START_USING".tr()}
                                </Button>
                                {show && (
                                    <div
                                        className="modal fade show"
                                        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                                        tabIndex={-1}
                                        aria-labelledby="staticBackdropLabel"
                                        aria-hidden="true"
                                    >
                                        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h1 className="modal-title fs-5 mb-0" id="staticBackdropLabel">
                                                        {"HOME_SEND_US_EMAIL".tr()}
                                                    </h1>
                                                    <button
                                                        type="button"
                                                        className="btn-close"
                                                        onClick={handleClose}
                                                        aria-label="Close"
                                                    ></button>
                                                </div>
                                                <form onSubmit={submitForm} className="sal-form-signin mb-4">
                                                    <div className="modal-body">
                                                        <div className="row">
                                                            <div className="col-12 col-md-6 mb-3">
                                                                <p className="sal-text-label-form mb-2">{"FULL_NAME".tr()}</p>
                                                                <FormControl variant="outlined" fullWidth>
                                                                    <OutlinedInput
                                                                        type="text"
                                                                        name="fullName"
                                                                        onChange={handleChange}
                                                                        placeholder={"FULL_NAME_CAPTION_TXT".tr()}
                                                                        startAdornment={
                                                                            <InputAdornment position="start">
                                                                                <Person />
                                                                            </InputAdornment>
                                                                        }
                                                                    />
                                                                </FormControl>
                                                            </div>
                                                            <div className="col-12 col-md-6 mb-3">
                                                                <p className="sal-text-label-form mb-2">{"COMPANY_TXT".tr()}</p>
                                                                <FormControl variant="outlined" fullWidth>
                                                                    <OutlinedInput
                                                                        type="text"
                                                                        name="company"
                                                                        onChange={handleChange}
                                                                        placeholder={"COMPANY_CAPTION_TXT".tr()}
                                                                        startAdornment={
                                                                            <InputAdornment position="start">
                                                                                <CorporateFareRounded />
                                                                            </InputAdornment>
                                                                        }
                                                                    />
                                                                </FormControl>
                                                            </div>
                                                            <div className="col-12 col-md-6 mb-3">
                                                                <p className="sal-text-label-form mb-2">{"EMAIL_TXT".tr()}</p>
                                                                <FormControl variant="outlined" fullWidth>
                                                                    <OutlinedInput
                                                                        type="text"
                                                                        name="email"
                                                                        onChange={handleChange}
                                                                        placeholder={"EMAIL_CAPTION_TXT".tr()}
                                                                        startAdornment={
                                                                            <InputAdornment position="start">
                                                                                <EmailRounded />
                                                                            </InputAdornment>
                                                                        }
                                                                    />
                                                                </FormControl>
                                                            </div>
                                                            <div className="col-12 col-md-6 mb-3">
                                                                <p className="sal-text-label-form mb-2">{"PHONE_NUMBER_TXT".tr()}</p>
                                                                <FormControl variant="outlined" fullWidth>
                                                                    <OutlinedInput
                                                                        type="text"
                                                                        name="phone"
                                                                        onChange={handleChange}
                                                                        placeholder={"PHONE_NUMBER_CAPTION_TXT".tr()}
                                                                        startAdornment={
                                                                            <InputAdornment position="start">
                                                                                <PhoneRounded />
                                                                            </InputAdornment>
                                                                        }
                                                                    />
                                                                </FormControl>
                                                            </div>
                                                            <div className="col-12 mb-3">
                                                                <p className="sal-text-label-form mb-2">{"DESC_TXT".tr()}</p>
                                                                <FormControl variant="outlined" fullWidth>
                                                                    <OutlinedInput
                                                                        type="text"
                                                                        name="description"
                                                                        onChange={handleChange}
                                                                        multiline
                                                                        rows={4}
                                                                        placeholder={"DESC_CAPTION_TXT".tr()}
                                                                    />
                                                                </FormControl>
                                                            </div>
                                                            {/* Captcha */}
                                                            <div className="col-12 mb-3">
                                                                <p className="sal-text-label-form mb-2">{"HOME_CAPTCHA".tr()}</p>
                                                                <div className="d-flex align-items-center">
                                                                    <strong className="me-2">{captchaQuestion} = </strong>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control font-13"
                                                                        value={userAnswer}
                                                                        onChange={(e) => setUserAnswer(e.target.value)}
                                                                        placeholder={"HOME_ANSWER".tr()}
                                                                        style={{ maxWidth: "100px" }}
                                                                    />
                                                                    <Button
                                                                        type="button"
                                                                        variant="primary"
                                                                        size="small"
                                                                        onClick={generateCaptcha}
                                                                        className="ms-2"
                                                                    >
                                                                        <Refresh />
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <Button variant="secondary" className="pt-2 pb-2" type="button" onClick={handleClose}>
                                                            {"CANCEL_TXT".tr()}
                                                        </Button>
                                                        <Button variant="primary" className="pt-2 pb-2" type="submit">
                                                            {"SUBMIT_TXT".tr()}
                                                        </Button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="row mb-2">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <VerifiedUserRounded className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_IMPROVE_EFFICIENCY_AND_TRANSPARENCY".tr()}{" "}.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-12">
                                        <div className="d-flex align-items-center gap-4">
                                            <PhoneRounded className="text-primary" />
                                            <div>
                                                <p className="sal-bigdata-text-one-extra">
                                                    {"HOME_CONTACT_US_FOR_FREE".tr()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Mobile View */}
                    <div className="sal-homepage-content-mob d-block d-md-none">
                        <div className="row">
                            <div
                                className="col-12 col-md-6 d-flex align-items-center justify-content-center mb-5"
                                align="center"
                            >
                                <img src={BigData} alt="Technology" width={"90%"} />
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="row mb-4">
                                    <div className="col-12 col-md-2 mb-3" align="center">
                                        <img src={Lock} alt="BigData" width={60} />
                                    </div>
                                    <div className="col-12 col-md-10 text-center">
                                        <p className="sal-bigdata-text-one font-18 mb-2">
                                            {"HOME_VAULT_PROTECTION".tr()}
                                        </p>
                                        <p className="sal-bigdata-text-two mb-2 font-15">
                                            {"HOME_CALCULATE_PRECISE".tr()}
                                        </p>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-12 col-md-2 mb-3" align="center">
                                        <img src={Wallet} alt="BigData" width={60} />
                                    </div>
                                    <div className="col-12 col-md-10 text-center">
                                        <p className="sal-bigdata-text-one font-18 mb-2">
                                            {"HOME_AI_INSURANCE".tr()}
                                        </p>
                                        <p className="sal-bigdata-text-two mb-2 font-15">
                                            {"HOME_CALCULATING_PRECISE".tr()}
                                        </p>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-12 col-md-2 mb-3" align="center">
                                        <img src={Chart} alt="BigData" width={60} />
                                    </div>
                                    <div className="col-12 col-md-10 text-center">
                                        <p className="sal-bigdata-text-one font-18 mb-2">
                                            {"HOME_TARGETED_SEGMENT".tr()}
                                        </p>
                                        <p className="sal-bigdata-text-two mb-2 font-15">
                                            {"HOME_PREDICT_INFLUENTIAL".tr()}
                                        </p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-2 mb-3" align="center">
                                        <img src={Chart} alt="BigData" width={60} />
                                    </div>
                                    <div className="col-12 col-md-10 text-center">
                                        <p className="sal-bigdata-text-one font-18 mb-2">
                                            {"HOME_STRATEGIC".tr()}
                                        </p>
                                        <p className="sal-bigdata-text-two mb-2 font-15">
                                            {"HOME_ENHANCE".tr()}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="tutorials" className="sal-homepage-content">
                <div className="sal-homepage-content-two">
                    <div className="container">
                        {/* Desktop View */}
                        <h2 className="sal-bigdata-step-title d-none d-md-block">
                            {"HOME_GET_STARTED_IN".tr()}
                        </h2>
                        <p className="sal-bigdata-step-desc mb-0 d-none d-md-block">
                            {"HOME_EASY_WAY".tr()}
                        </p>
                        {/* Mobile View */}
                        <h4 className="sal-bigdata-step-titlemob d-block d-md-none">
                            {"HOME_GET_STARTED_IN".tr()}
                        </h4>
                        <p className="sal-bigdata-step-desc mb-0 font-15 d-block d-md-none">
                            {"HOME_EASY_WAY".tr()}
                        </p>

                        <div className="sal-get-started">
                            <div className="row">
                                <div className="col-12 col-md-3 mb-3 ps-1 pe-1" align="center">
                                    <img src={StepOne} alt="Step" width={"40%"} />
                                    <p className="sal-get-started-one">1. {"HOME_SIGN_IN".tr()}</p>
                                    <p className="sal-get-started-two mb-0">
                                        {"HOME_OPEN_BEEVER".tr()}
                                    </p>
                                </div>
                                <div className="col-12 col-md-3 mb-3 ps-1 pe-1" align="center">
                                    <img src={StepTwo} alt="Step" width={"40%"} />
                                    <p className="sal-get-started-one">2. {"HOME_REQUEST_AMOUNT".tr()}</p>
                                    <p className="sal-get-started-two mb-0">
                                        {"HOME_SELECT_YOUR".tr()}
                                    </p>
                                </div>
                                <div className="col-12 col-md-3 mb-3 ps-1 pe-1" align="center">
                                    <img src={StepThree} alt="Step" width={"40%"} />
                                    <p className="sal-get-started-one">3. {"HOME_CONFIRMATION".tr()}</p>
                                    <p className="sal-get-started-two mb-0">
                                        {"HOME_CONFIRM_YOUR_REQUESTED".tr()}
                                    </p>
                                </div>
                                <div className="col-12 col-md-3 mb-3 ps-1 pe-1" align="center">
                                    <img src={StepThree} alt="Step" width={"40%"} />
                                    <p className="sal-get-started-one">4. {"HOME_DONE".tr()}</p>
                                    <p className="sal-get-started-two mb-0">
                                        {"HOME_CONGRATULATIONS".tr()}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="contact" className="sal-homepage-footer">
                <div className="container ps-4 pe-4">
                    <div className="row">
                        {/* <div className="col-12 col-md-10 mb-3"> */}
                        <div className="col-12 mb-3">
                            <div className="row gap-5 gap-md-0">
                                <div className="col-12 col-md-4">
                                    {/* <p className="sal-homepage-footer-title">{"HOME_PRODUCT".tr()}</p> */}
                                    <img src={LogoText} alt={"Sal Ad"} width={120} />
                                    <p className="sal-homepage-footer-desc mt-3">
                                        <span className="mb-2 d-block">
                                            PT.Tugboat Trading Indonesia
                                        </span>
                                        {"ADDRESS_1".tr()}
                                        <br />
                                        {"ADDRESS_2".tr()}
                                        <br />
                                        {"ADDRESS_3".tr()}
                                    </p>
                                    <div className="sal-homepage-footer-contact">
                                        <MailOutlineIcon className="fill-muted" /> Business@sal-ad.net
                                    </div>
                                    <div className="sal-homepage-footer-contact">
                                        <PhoneOutlined className="fill-muted" /> 021-27098659
                                    </div>

                                    {/* <p className="sal-homepage-footer-title">{"HOME_PRODUCT".tr()}</p>
                                    <Button
                                        to={"/"}
                                        variant="link"
                                        className="sal-btn-link-footer"
                                    >
                                        {"HOME_DOCUMENTATIONS".tr()}
                                    </Button>
                                    <Button
                                        to={"/"}
                                        variant="link"
                                        className="sal-btn-link-footer"
                                    >
                                        {"HOME_INTEGRATIONS".tr()}
                                    </Button>
                                    <Button
                                        to={"/"}
                                        variant="link"
                                        className="sal-btn-link-footer"
                                    >
                                        {"HOME_PRICING".tr()}
                                    </Button>
                                    <Button
                                        to={"/"}
                                        variant="link"
                                        className="sal-btn-link-footer"
                                    >
                                        {"HOME_API".tr()}
                                    </Button> */}
                                </div>
                                <div className="col-12 col-md-2">
                                    <p className="sal-homepage-footer-title">{"HOME_COMPANY".tr()}</p>
                                    <Button
                                        to={"/"}
                                        variant="link"
                                        className="sal-btn-link-footer"
                                    >
                                        {"HOME_ABOUT_US".tr()}
                                    </Button>
                                    <a
                                        href={"https://admin.sal-ad.com/auth/login"}
                                        variant="link"
                                        target="_blank"
                                        className="sal-btn-link-footer"
                                    >
                                        {"HOME_ACCESS_PARTNERS".tr()}
                                    </a>
                                    {/* <Button
                                        to={"/"}
                                        variant="link"
                                        className="sal-btn-link-footer"
                                    >
                                        {"HOME_CAREERS".tr()}
                                    </Button> */}
                                </div>
                                <div className="col-12 col-md-2">
                                    <p className="sal-homepage-footer-title">{"HOME_SUPPORT".tr()}</p>
                                    <Button
                                        to={"/"}
                                        variant="link"
                                        className="sal-btn-link-footer"
                                    >
                                        {"HOME_KNOWLEDGE".tr()}
                                    </Button>
                                    <Button
                                        to={"/"}
                                        variant="link"
                                        className="sal-btn-link-footer"
                                    >
                                        {"HOME_TUTORIALS".tr()}
                                    </Button>
                                    <Button
                                        to={"/"}
                                        variant="link"
                                        className="sal-btn-link-footer"
                                    >
                                        {"HOME_DOCUMENTS".tr()}
                                    </Button>
                                    <Button
                                        to={"/"}
                                        variant="link"
                                        className="sal-btn-link-footer"
                                    >
                                        {"HOME_GUIDELINES".tr()}
                                    </Button>
                                </div>
                                 <div className="col-12 col-md-4">
                                    <p className="sal-homepage-footer-title">{"HOME_STAYUPTODATE".tr()}</p>
                                    <p className="sal-homepage-footer-desc">
                                        {"HOME_SUBSCRIBE".tr()}
                                    </p>
                                    <FormControl variant="outlined" fullWidth>
                                        <OutlinedInput
                                            type="text"
                                            name="bsaMail"
                                            placeholder={"Enter email"}
                                            className="sal-form-email"
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <MailOutlineIcon className="fill-muted" />
                                                </InputAdornment>
                                            }
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <Button variant="primary">
                                                        <SendIcon className="fill-white" />
                                                    </Button>
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-12 col-md-5">
                            <div className="row">
                                <div className="col-12 col-md-6 mb-5">
                                    <p className="sal-homepage-footer-title">{"HOME_CONTACT_US".tr()}</p>
                                    <p className="sal-homepage-footer-desc">
                                        Plaza Indonesia, Level 5, Unit E021AB
                                        <br />
                                        Jl. M.H Thamrin Kavling 28-30
                                        <br />
                                        Kel. Gondangdia, Kec. Menteng,
                                        <br />
                                        Jakarta Pusat 10350
                                    </p>
                                    <p className="sal-homepage-footer-desc mb-0">
                                        {"HOME_EMAIL_CONTACT_US".tr()}
                                    </p>
                                </div>
                                <div className="col-12 col-md-6">
                                    <p className="sal-homepage-footer-title">{"HOME_STAYUPTODATE".tr()}</p>
                                    <p className="sal-homepage-footer-desc">
                                        {"HOME_SUBSCRIBE".tr()}
                                    </p>
                                    <FormControl variant="outlined" fullWidth>
                                        <OutlinedInput
                                            type="text"
                                            name="bsaMail"
                                            placeholder={"HOME_ENTER_EMAIL".tr()}
                                            className="sal-form-email"
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <MailOutlineIcon className="fill-muted" />
                                                </InputAdornment>
                                            }
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <Button variant="primary">
                                                        <SendIcon className="fill-white" />
                                                    </Button>
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="sal-break-line"></div>
                <div className="container">
                    <div className="row align-items-center justify-content-between">
                        {/* Desktop View */}
                        <div className="col-md-2 d-none d-md-block">
                            <img src={LogoText} alt={"Sal Ad"} width={120} />
                        </div>
                        {/* Mobile View */}
                        <div className="col-12 d-block d-md-none mb-4" align="center">
                            <img src={LogoText} alt={"Sal Ad"} width={160} />
                        </div>
                        <div className="col-12 col-md-8">
                            <p className="sal-copyright mb-0 text-center">
                                © 2022 SalAd All rights reserved.
                            </p>
                            <div className="d-block d-md-none mb-4"></div>
                        </div>
                        {/* Desktop View */}
                        <div className="col-md-2 d-none d-md-block">
                            <div className="d-flex align-items-center justify-content-between">
                                <Link to={"/"} alt="Social Media" className="me-3">
                                    <img src={FB} alt={"Socmed"} width={24} />
                                </Link>
                                <Link to={"/"} alt="Social Media" className="me-3">
                                    <img src={IG} alt={"Socmed"} width={24} />
                                </Link>
                                <Link to={"/"} alt="Social Media" className="me-3">
                                    <img src={TW} alt={"Socmed"} width={24} />
                                </Link>
                                <Link to={"/"} alt="Social Media">
                                    <img src={YT} alt={"Socmed"} width={24} />
                                </Link>
                            </div>
                        </div>
                        {/* Desktop View */}
                        <div className="col-6 d-block d-md-none mx-auto">
                            <div className="d-flex align-items-center justify-content-between">
                                <Link to={"/"} alt="Social Media" className="me-3">
                                    <img src={FB} alt={"Socmed"} width={24} />
                                </Link>
                                <Link to={"/"} alt="Social Media" className="me-3">
                                    <img src={IG} alt={"Socmed"} width={24} />
                                </Link>
                                <Link to={"/"} alt="Social Media" className="me-3">
                                    <img src={TW} alt={"Socmed"} width={24} />
                                </Link>
                                <Link to={"/"} alt="Social Media">
                                    <img src={YT} alt={"Socmed"} width={24} />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomePage;
